module.exports = __webpack_public_path__ + "static/media/ascent_horizon_rendering_mobile.10d85c6e.jpg";